import { useState, useEffect } from 'react';
import { Box, Button, Input, Typography, Stack } from '@mui/joy';

function CategoryForm({ initialData, onSave, onCancel }) {
  const [name, setName] = useState('');

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || '');
    } else {
      setName('');
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSave({ name: name.trim() });
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Box>
          <Typography level="body-sm" sx={{ mb: 0.5 }}>Название категории *</Typography>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Например, Электросамокаты"
            autoFocus
            fullWidth
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, pt: 1 }}>
          <Button type="submit">{initialData ? 'Сохранить' : 'Добавить'}</Button>
          <Button type="button" variant="soft" color="neutral" onClick={onCancel}>Отмена</Button>
        </Box>
      </Stack>
    </Box>
  );
}

export default CategoryForm;
